<template>
  <div class="wssa">
    <header>
      <div class="navbar navbar-white bg-white shadow-sm">
        <div class="container d-flex justify-content-between">
          <div class="navbar-brand d-flex align-items-center" style="padding:0;">
            <router-link to="/"><img v-if="LogoUrl" :src="LogoUrl" alt="logo" style="height:54px"></router-link>
            <div class="topSelIndex"><a href="/">首页</a></div>
            <!-- <div class="topSelIndex" style="margin-left:10px;"><a href="/course">课程分类</a></div> -->
            <el-dropdown style="margin-top:7px;" >
              <span class="el-dropdown-link" style="font-size:1rem">
                <a href="/course/0" style="color:#666;">课程分类<i class="el-icon-arrow-down el-icon--right"></i></a>
              </span>
              <el-dropdown-menu slot="dropdown">
                <router-link :to="'/course/'+index" v-for="(item,index) in ClassList" :key="index">
                  <el-dropdown-item>
                    {{item.Name}}
                  </el-dropdown-item>
                </router-link>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div>
            <el-tooltip placement="top" class="ifonTime" effect="light" v-if="ifonTime.length!=0">
              <div slot="content">
                <div style="margin:5px 0;font-size:14px;" v-for="(item,index) in ifonTime" :key="index">分类《{{item.ClassName1}} - {{item.ClassName2}}》在 {{item.endTime}} 到期</div>
              </div>
              <div class="el-icon-warning"></div>
            </el-tooltip>
            <!-- <router-link to="/course" class="indeBin">
              <div class="user2">课程</div>
            </router-link> -->
            <dir v-if="getToken" class="user" @click.stop="UserShow = !UserShow">
              <div class="user1 el-icon-s-custom"></div>
              <div>{{userIfon.UserName}}</div>
              <div class="user3 el-icon-arrow-down"></div>
              <div class="user4" v-show="UserShow">
                <router-link to="/memberCentre" class="indeBin">
                  <div class="user4a">会员中心</div>
                </router-link>
                <div class="user4a" @click="onOutLogin">退出</div>
              </div>
            </dir>
            <dir v-else class="user">
              <div class="user2" @click="dialogVisible=true">登录</div>
              <router-link :to="'/login'">
                <div class="user2">注册</div>
              </router-link>
            </dir>
          </div>

        </div>
      </div>
    </header>
    <router-view ref="child" />
    <footer class="text-muted">
      <div class="container"></div>
    </footer>

    <el-dialog :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false" @close="closeDialog">
      <div class="logins">
        <div class="logins1">登录</div>
        <div class="logins2">
          <div class="logins2a i-zhanghuffffffpx"></div>
          <input type="text" v-model="login.username" placeholder="请输入用户名">
        </div>
        <div class="logins2">
          <div class="logins2a i-mimaffffffpx"></div>
          <input type="password" v-model="login.password" placeholder="请输入密码">
        </div>
        <el-button class="logins3" type="primary" @click="onLogin">登录</el-button>
        <div class="logins4">
          没有账号？ <span @click="toRegistered">点击注册</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";
import { getToken, removeToken, setToken } from '@/utils/auth';
var int = null;
export default {
  components: {},
  data() {
    return {
      ClassList: '',
      login: { username: '', password: '' },
      getToken: getToken() != undefined,
      activeName: 0,
      IsLogin: false,
      UserShow: false,
      dialogVisible: false,
      form: { password: '', username: '' },
      LogoUrl: '',
      ifonTime: [],
      userIfon: { UserName: '' }
    };
  },

  computed: {
    isLogin() {
      return this.$store.getters.getTokenValue;　　//需要监听的数据
    }
  },
  watch: {
    isLogin(newVal, oldVal) {
      this.getToken = getToken() != undefined;
      if (int) return
      int = setInterval(this.stagetLoginStatus, 10000)
    }
  },
  mounted() { },
  created() {
    if (this.$store.getters.getTokenValue && !int) int = setInterval(this.stagetLoginStatus, 10000)
    var thas = this;
    this.sApi('getLogo', { token: this.$store.getters.getTokenValue }).then(res => {
      this.ClassList = res.ClassList;
      this.LogoUrl = this.ossUrl + res.logoUrl;
      if (res.ifonTime) this.ifonTime = res.ifonTime;
      if (res.userIfon) this.userIfon = res.userIfon;
    })
    document.addEventListener("click", () => { thas.UserShow = false; }, false);
  },
  methods: {
    toRegistered() {
      this.dialogVisible = false;
      this.$router.push({ path: "/login" });
    },

    onLogin() {
      if (this.login.username == '') { this.$message({ message: '请输入用户名', type: 'warning' }); return; }
      if (this.login.password == '') { this.$message({ message: '请输入密码', type: 'warning' }); return; }
      this.sApi('onLogin', this.login).then(res => {
        if (res.code == 200) {
          setToken(res.message);
          this.$store.commit('setTokenValue', res.message);
          this.$message({ message: '登录成功', type: 'success' });
          this.dialogVisible = false;
          this.$router.push({ path: "/" }).catch(data => { });
          if (res.ifonTime) this.ifonTime = res.ifonTime;
        }
        else this.$message({ message: "账号或密码错误", type: 'warning' });
      })
    },
    stagetLoginStatus() {
      this.sApi('getLoginStatus', { token: this.$store.getters.getTokenValue }).then(res => {
        if (res == 0) {
          clearInterval(int);
          this.$message({ message: '此账号已在其他设备登录', type: 'success' });
          removeToken();
          this.$store.commit('setTokenValue', '');
          this.$router.push({ path: "/" }).catch(data => { });
          this.ifonTime = [];
        }
      })
    },
    onOutLogin() {
      clearInterval(int);
      removeToken();
      this.$store.commit('setTokenValue', '');
      this.$message({ message: '退出成功', type: 'success' });
      this.$router.push({ path: "/" }).catch(data => { });
      this.ifonTime = [];
    },
    closeDialog(){
      // this.$router.go(0)
      location.reload()
    }
  },
};
</script>

<style lang="scss">
.el-tooltip__popper.is-light {
  border-color: #999 !important;
}
.ifonTime {
  font-size: 20px;
  margin-top: 19px;
  color: #e6a23c;
}

.wssa {
  width: 100%;
  overflow: hidden;
}
html,
body {
  width: 100%;
}
.topSelIndex {
  margin: 0 15%;
  font-size: 1rem;
  margin-top: 7px;
  a {
    color: #606266;
  }
}

@media screen and (min-width: 1200px) {
  .container {
    max-width: 1160px;
  }
}

// .container {
//   padding-left: 0;
//   padding-right: 0;
// }
.logins {
  width: 100%;
  padding: 0px 60px 60px;
  .logins1 {
    width: 100%;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #666;
  }
  .logins2 {
    width: 100%;
    float: left;
    border-bottom: 1px solid #e2dee0;
    margin-top: 30px;
    .logins2a {
      float: left;
      font-size: 22px;
      color: #999;
    }
    input {
      width: calc(100% - 22px);
      padding-left: 15px;
      font-size: 16px;
      border: 0;
      line-height: 35px;
    }
  }
  .logins3 {
    width: 100%;
    margin-top: 30px;
  }
  .logins4 {
    width: 100%;
    text-align: center;
    margin-top: 5px;
    span {
      cursor: pointer;
      color: #409eff;
      &:hover {
        color: #5256c4;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  strong {
    font-size: 20px !important;
  }
}

.kksyw {
  .el-input {
    margin-bottom: 15px;
  }
}
.indeBin {
  float: left;
  line-height: 60px;
  margin-right: 30px;
}
.user {
  float: right;
  position: relative;
  margin: 10px;
  padding: 0;
  line-height: 40px;
  cursor: pointer;
  div {
    float: left;
  }
  .user1 {
    width: 40px;
    height: 40px;
    border-radius: 999px;
    background-color: #ddd;
    text-align: center;
    line-height: 40px;
    color: #aaa;
    font-size: 26px;
    margin-right: 5px;
  }
  .user2 {
    padding-left: 10px;
    color: #333;
    &:hover {
      color: #007bff;
    }
  }
  .user3 {
    line-height: 40px;
    font-size: 20px;
    color: #333;
  }
  .user4 {
    position: absolute;
    top: 45px;
    right: 0;
    width: 120px;
    border: 1px solid #b8b8b8;
    background-color: #fff;
    border-radius: 5px;
    text-align: center;
    padding: 5px 0;
    z-index: 99;
    .user4a {
      width: 100%;
      color: #666;
      font-size: 14px;
      line-height: 30px;
      &:hover {
        background-color: #eee;
      }
    }
    a {
      width: 100%;
      text-align: center;
    }
  }
}

html,
body {
  padding: 0;
  margin: 0;
  background-color: #f8f9fa;
}
div {
  box-sizing: border-box;
}
</style>